<template>
  <div>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <!-- <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button> -->
        <div></div>
        <div>
          <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
          <el-button
          type="primary"
          @click="outExeAll('memberList')"
          >전체출력</el-button>
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { sendHistory } from "@/api/api";
export default {
  name: "send",
  mixins: [mixin_list(sendHistory)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t('send.create_time'),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t('send.to_email'),
          sortable: true,
          prop: "to_email",
        },
        {
          label: this.$t('send.real_name'),
          sortable: true,
          prop: "real_name",
        },
      ],
    };
  },
  computed: {
    
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>